import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import AlarmClockDraw from '@/common/svg/alarm-clock-gears-draw.svg';
import ManagerDraw from '@/common/svg/manager-draw.svg';
import QuestionnaireDraw from '@/common/svg/questionnaire-draw.svg';
import { FeatureCard } from '@/shared/ui/FeatureCard';

const GetMoneySteps = () => {
  const navigate = useNavigate();
  const onSubmit = () => {
    navigate('/auth');
  };
  return (
    <section className={cn('section', styles.section)}>
      <div className="container">
        <h2>
          <FormattedMessage defaultMessage="Два простых шага и деньги у Вас!" />
        </h2>
        <div className={styles.main}>
          <div className={styles.row}>
            <FeatureCard Icon={QuestionnaireDraw}>
              <h4 className={styles.cardTitle}>
                <FormattedMessage defaultMessage="Заполните анкету на нашем сайте" />
              </h4>
            </FeatureCard>
            <FeatureCard Icon={AlarmClockDraw}>
              <h4 className={styles.cardTitle}>
                <FormattedMessage defaultMessage="Ожидайте наше решение в течение 10 минут!" />
              </h4>
            </FeatureCard>
          </div>
          <FeatureCard
            Icon={ManagerDraw}
            buttonId="how-get-money-steps"
            buttonTitle={<FormattedMessage defaultMessage="Получить деньги" />}
            buttonHandler={onSubmit}
          >
            <h4 className={styles.cardTitle}>
              <FormattedMessage defaultMessage="В случае одобрения микрокредита, наш кредитный менеджер свяжется с Вами" />
            </h4>
          </FeatureCard>
        </div>
      </div>
    </section>
  );
};

export default GetMoneySteps;
